import api from "@/utils/axios";

const DISCOUNT_API_URL = `/discounts`;

export default {
  namespaced: true,
  state: {
    discount: null,
    discounts: [],
    loading: false,
    error: null,
  },
  mutations: {
    SET_DISCOUNT(state, discount) {
      state.discount = discount;
    },
    SET_DISCOUNTS(state, discounts) {
      state.discounts = discounts;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_DISCOUNT(state) {
      state.discount = null;
      state.error = null;
    },
    CLEAR_DISCOUNTS(state) {
      state.discounts = [];
      state.error = null;
    },
  },
  actions: {
    async fetchDiscount({ commit }, discountId) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.get(`${DISCOUNT_API_URL}/${discountId}/`);
        commit("SET_DISCOUNT", res.data.data);
        return res.data.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to fetch discounts"
        );
        return [];
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async createDiscount({ commit }, data) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${DISCOUNT_API_URL}/new/`, data);
        commit("SET_DISCOUNT", res.data.data);
        return res.data.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to create discount"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateDiscount({ commit }, { id, data }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.patch(`${DISCOUNT_API_URL}/${id}/`, data);
        commit("SET_DISCOUNT", res.data.data);
        return res.data.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to update discount"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteDiscount({ commit }, id) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        await api.delete(`${DISCOUNT_API_URL}/${id}/`);
        commit("CLEAR_DISCOUNT");
        return true;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to delete discount"
        );
        return false;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    discount: (state) => state.discount,
    discounts: (state) => state.discounts,
    discountLoading: (state) => state.loading,
    discountError: (state) => state.error,
  },
};
